import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded$3 = ["left", "right"];

var SideBySide = function SideBySide(_ref) {
  var left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center"
  }, rest), /*#__PURE__*/React.createElement("div", null, left), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "flex-end"
  }, right));
};

SideBySide.propTypes = {
  left: PropTypes.any,
  right: PropTypes.any
};

var _excluded$2 = ["title", "titleVariant", "titleProps", "subTitle", "subTitleProps", "actions", "actionProps", "actionLabel", "announceTitle", "sideBySideProps"];

var Title = function Title(_ref) {
  var title = _ref.title,
      titleVariant = _ref.titleVariant,
      titleProps = _ref.titleProps,
      subTitle = _ref.subTitle,
      subTitleProps = _ref.subTitleProps,
      actions = _ref.actions,
      actionProps = _ref.actionProps,
      actionLabel = _ref.actionLabel,
      _ref$announceTitle = _ref.announceTitle,
      announceTitle = _ref$announceTitle === void 0 ? false : _ref$announceTitle,
      sideBySideProps = _ref.sideBySideProps,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    width: "100%"
  }), /*#__PURE__*/React.createElement(SideBySide, _extends({}, sideBySideProps, {
    left: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, _extends({
      variant: titleVariant
    }, titleProps, {
      "aria-live": announceTitle ? 'assertive' : undefined
    }), title), !isEmpty(subTitle) && /*#__PURE__*/React.createElement(Box, _extends({
      py: 2
    }, subTitleProps), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, subTitle))),
    right: !isEmpty(actionLabel) ? /*#__PURE__*/React.createElement(Box, {
      my: 2
    }, /*#__PURE__*/React.createElement(Button, actionProps, actionLabel)) : !isEmpty(actions) && /*#__PURE__*/React.createElement(Box, {
      my: 2
    }, actions)
  })));
};

Title.propTypes = {
  title: PropTypes.node,
  titleVariant: PropTypes.string,
  titleProps: PropTypes.object,
  subTitle: PropTypes.node,
  subTitleProps: PropTypes.object,
  actions: PropTypes.node,
  actionProps: PropTypes.object,
  actionLabel: PropTypes.string,
  announceTitle: PropTypes.bool,
  sideBySideProps: PropTypes.object
};

var _excluded$1 = ["actionProps", "titleProps"];

var PageTitleComp = function PageTitleComp(_ref) {
  var actionProps = _ref.actionProps,
      titleProps = _ref.titleProps,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement(Title, _extends({
    pt: {
      sm: 4,
      xs: 3
    },
    pb: 2
  }, rest, {
    titleProps: _extends({
      component: 'h1'
    }, titleProps),
    titleVariant: "h3",
    announceTitle: true,
    actionProps: _extends({
      variant: 'contained',
      color: 'primary'
    }, actionProps)
  }));
};

PageTitleComp.propTypes = _extends({}, Title.propTypes);

var _excluded = ["actionProps"];

var SectionTitle = function SectionTitle(_ref) {
  var actionProps = _ref.actionProps,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Title, _extends({
    pt: {
      sm: 4,
      xs: 3
    },
    pb: 2,
    titleVariant: "h6"
  }, rest, {
    actionProps: _extends({
      variant: 'text',
      color: 'primary'
    }, actionProps)
  }));
};

SectionTitle.propTypes = _extends({}, Title.propTypes);

export { PageTitleComp as PageTitle, SectionTitle, Title };
//# sourceMappingURL=index.module.js.map
